import React, { useEffect } from 'react';
import '../css/navBar.css';
import '../css/registro.css';

function EditarBorrarRepresentante(props){


    /*function agregarFila(){
        var agregar = true;
        for (var i = 1; i <= props.cantRepresentantes + 1; i++) {
            const apellido = document.getElementById("apellidoText" + i).value;
            const nombre = document.getElementById("nombreText" + i).value;
            const cargo = document.getElementById("cargoText" + i).value;
            if(!apellido || !nombre || !cargo){
                agregar = false
                break;
            }
        }
        if(agregar)
            props.setCantRepresentantes(props.cantRepresentantes + 1)
    }  
    function eliminarRepresentante(id){
        document.getElementById("apellidoText" + id).value = "";
        document.getElementById("nombreText" + id).value = "";
        document.getElementById("cargoText" + id).value = "";
         
    }  */

   /* useEffect(() => {
        if(props.representantes !== null && props.representantes !== undefined && !document.getElementById("apellidoText1").value){
            props.representantes.map((x, i) => {
                console.log(x.nombre)
                document.getElementById("apellidoText" + (i + 1)).value = x.apellido;
                document.getElementById("nombreText" + (i + 1) ).value = x.nombre;
                document.getElementById("cargoText" + (i + 1)).value = x.cargo;
            })
        }
    },[props.cantRepresentantes]) */
    function eliminarRepresentante(id){
       
        let representantesNuevo = []; 
        props.representantes.map((x, i) => {
            if(x.id.localeCompare(id)!== 0){
                const apellido = document.getElementById("apellidoEditText" + (x.id)).value;
                const nombre = document.getElementById("nombreEditText" + (x.id)).value;
                const cargo = document.getElementById("cargoEditText" + (x.id)).value;
            
                representantesNuevo.push({id:x.id, apellido: apellido, nombre: nombre, cargo:cargo, eliminado: false})
            }
        })
        props.setRepresentantes(representantesNuevo)
        //props.setRepresentantes(props.representantes.filter(item => id !== item.id));
        props.setRepresenElim(id);
    }
    useEffect(() => {
        props.representantes.map((x, i) => {
            document.getElementById("apellidoEditText" + (x.id)).value = x.apellido;
            document.getElementById("nombreEditText" + (x.id)).value = x.nombre;
            document.getElementById("cargoEditText" + (x.id)).value = x.cargo;
       
        })
    },[props.representantes]) 
    return(  
        <>  
            <div id="datosRepresentanteActual">
                <div className='row '>
                    <div className='offset-sm-1'>
                        <div class="mb-3 mt-4">
                            <label class="form-label letraDatos">{props.text}</label>
                        </div>
                    </div>
                </div>
                
               
                <div className='row'>
                    <div className='col offset-sm-1'>
                        <div className='rounded-4 letraDatos text-center tablaRepresentantes'>
                            <div className='row  py-2 colorPrincipal text-white mx-0'>
                                <div className='col'>
                                    Nombre
                                </div>
                                <div className='col'>
                                    Apellido
                                </div>
                                <div className='col'>
                                    Cargo
                                </div>
                                <div className='col'>
                                    Eliminar
                                </div>
                            </div>
                            {props.representantes.length !== 0?
                             
                            props.representantes.map(function(elem, i){
                                return(    
                                    <div className='row mx-0 bordeTopRepresentantes'  id={'rowRepren' + elem.id}>
                                        <div className='col bordeEndRepresentantes p-0'>
                                            <input type="text" id={"nombreEditText"+ elem.id} class="form-control form-normal text-center bg-transparent textRepresentante letraDatos" 
                                            placeholder="Nombre" aria-label="Nombre" defaultValue={elem.nombre}/>
                                        </div>
                                        <div className='col bordeEndRepresentantes p-0'>
                                            <input type="text" id={"apellidoEditText"+elem.id} class="form-control form-normal text-center bg-transparent textRepresentante letraDatos" placeholder="Apellido" 
                                            aria-label="Apellido" defaultValue={elem.apellido}/>
                                        </div>
                                        <div className='col p-0 bordeEndRepresentantes position-relative'>
                                            <input type="text" id={"cargoEditText" + elem.id} class="form-control form-normal bg-transparent text-center textRepresentante letraDatos" placeholder="Cargo" 
                                            aria-label="Cargo" defaultValue={elem.cargo}/>
                                        </div>
                                        <div className='col p-0 position-relative'>
                                            <button class="btn btn-outline-primary bold-botones w-100 rounded-0 border-0 btn-cuadrado" 
                                            onClick={()=>eliminarRepresentante(elem.id)}>Eliminar</button>
                                        </div>
                                    </div>
                                )
                            })
                            
                            :
                            <>
                                <p className='text-center my-4 textoTablas '>No se encontraron representantes</p>
                            </>
                            }
                            
                            {/*[...Array(props.cantRepresentantes)].map((x, i) => 
                                    <div className='row bordeTopRepresentantes mx-0'>
                                    <div className='col bordeEndRepresentantes p-0'>
                                        <input type="text" id={"nombreText" + (i + 2)} class="form-control text-center textRepresentante letraDatos"
                                        placeholder="Nombre" aria-label="Nombre" aria-describedby="button-addon2" onChange={agregarFila}/>
                                    </div>
                                    <div className='col bordeEndRepresentantes p-0'>
                                        <input type="text" id={"apellidoText" + (i + 2)} class="form-control text-center textRepresentante letraDatos" placeholder="Apellido" 
                                        aria-label="Apellido"  onChange={agregarFila}/>
                                    </div>
                                    <div className='col p-0 position-relative'>
                                        <input type="text" id={"cargoText" + (i + 2)}  class="form-control text-center textRepresentante letraDatos" placeholder="Cargo" 
                                        aria-label="Cargo"  onChange={agregarFila}/>
                                        <button type="button" class="btn-close btn-eliminar-representante" onClick={()=>eliminarRepresentante(i + 2)}></button>
                                    </div>
                                    </div>
                                    )*/
                                }
                        </div>
                    
                    </div>
                    <div className='col-sm-1'></div>
                </div>
                
            </div>
        </>
    );
}


export default EditarBorrarRepresentante;